import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "v-organizations" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__stats" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "action" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "description__footer" }

import { Plus, Trash01, Pencil02, X } from "utruckin-icons";
import { ref } from "vue";
import { onMounted } from "vue";
import { useOrganizationStore } from "@/features/organization/organization.store";
import {
  INewOrganization,
  IOrganization,
} from "@/features/organization/organization.types";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import { DateTime } from "luxon";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import { useNotification } from "@/utils/notification";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationView',
  setup(__props) {

const organizationStore = useOrganizationStore();
const { pushNotification } = useNotification();

const loading = ref<boolean>(false);
const organizations = ref<IOrganization[]>([]);

const modalItem = ref<any>();
const modalLoading = ref<boolean>(false);
const isModalVisible = ref<boolean>(false);
const modalType = ref<"create" | "edit">("create");

const getList = async () => {
  await organizationStore.getOrganizationList(loading, (res: any) => {
    if (res) {
      organizations.value = res;
    }
  });
};

const openModal = (type: "create" | "edit", item?: any) => {
  if (type == "create") {
    modalItem.value = {
      name: "",
      slug: "",
      billing_email: "",
      status: "active",
    };
    modalType.value = "create";
  } else {
    modalItem.value = { ...item };
    modalType.value = "edit";
  }
  modalLoading.value = false;
  isModalVisible.value = true;
};

const closeModal = () => {
  modalItem.value = {};
  isModalVisible.value = false;
  modalLoading.value = false;
};

const saveModal = async () => {
  if (modalType.value == "create") {
    if (!modalItem.value.name) {
      return;
    }

    await organizationStore.createOrganization(
      modalLoading,
      {
        billing_email: modalItem.value.billing_email,
        name: modalItem.value.name,
        slug: modalItem.value.name.toLowerCase().replace(/\s+/g, "_"),
        status: "active",
      },
      async (res: any) => {
        if (res) {
          pushNotification("Successfully created", "success");
          closeModal();
          await getList();
        }
      }
    );
  } else {
    if (!modalItem.value.name) {
      return;
    }
    await organizationStore.updateOrganization(
      modalLoading,
      {
        billing_email: modalItem.value.billing_email,
        name: modalItem.value.name,
        slug: modalItem.value.name.toLowerCase().replace(/\s+/g, "_"),
        status: "active",
      },
      modalItem.value.id,
      async (res: any) => {
        if (res) {
          pushNotification("Successfully saved", "success");
          closeModal();
          await getList();
        }
      }
    );
  }
};

function datepickerToUtcDateOnly(d: any) {
  return d
    ? DateTime.fromISO(d, {
        zone: "utc",
      })
        .setZone("America/New_York")
        .toFormat("MMM d, HH:mm")
    : "-";
}

const rowClick = (item: any, index: number) => {
  localStorage.setItem("organizationId", item.id);
  if (item.id) {
    router.push(`/all-tasks`);
  }
};

const deleteItem = async (item: any) => {
  const payload: INewOrganization = {
    name: item.name,
    billing_email: item.billing_email,
    slug: item.slug,
    status: "in_active",
  };

  await organizationStore.updateOrganization(
    loading,
    payload,
    item.id,
    async (res: any) => {
      if (res) {
        pushNotification("Successfully deleted", "success");
        await getList();
      }
    }
  );
};

onMounted(async () => {
  await getList();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "header__title" }, "All organization", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CommonButton, {
          type: "primary",
          label: "Add organization",
          prepend: "",
          prependIcon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal('create')))
        }, null, 8, ["prependIcon"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CommonTable, {
        headers: _unref(organizationStore).organizationHeaders,
        loading: loading.value,
        items: organizations.value,
        onRowClick: rowClick
      }, {
        id: _withCtx(({ index }) => [
          _createElementVNode("span", null, _toDisplayString(index + 1), 1)
        ]),
        created_time: _withCtx(({ item }) => [
          _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.created_time) || "-"), 1)
        ]),
        updated_time: _withCtx(({ item }) => [
          _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.updated_time) || "-"), 1)
        ]),
        billing_email: _withCtx(({ item }) => [
          _createElementVNode("span", null, _toDisplayString(item.billing_email || "-"), 1)
        ]),
        status: _withCtx(({ item }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["status", item.status ? '' : 'inactive'])
          }, _toDisplayString(item.status ? "active" : "inactive"), 3)
        ]),
        actions: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "action__item",
              onClick: ($event: any) => (openModal('edit', item))
            }, [
              _createVNode(_unref(Pencil02), { size: 18 })
            ], 8, _hoisted_6)), [
              [_directive_tooltip, {
                content: 'Edit',
                html: true,
              }]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "action__item",
              onClick: ($event: any) => (deleteItem(item))
            }, [
              _createVNode(_unref(Trash01), { size: 18 })
            ], 8, _hoisted_7)), [
              [_directive_tooltip, {
                content: 'Delete',
                html: true,
              }]
            ])
          ])
        ]),
        _: 1
      }, 8, ["headers", "loading", "items"])
    ]),
    _createVNode(CommonModal, {
      modelValue: isModalVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isModalVisible).value = $event)),
      title: modalType.value == 'create' ? 'Add organization' : 'Edit organization',
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeModal
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveModal
          })
        ])
      ]),
      default: _withCtx(() => [
        (modalItem.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(CommonInput, {
                  modelValue: modalItem.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalItem.value.name) = $event)),
                  label: "Name"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(CommonInput, {
                  modelValue: modalItem.value.billing_email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modalItem.value.billing_email) = $event)),
                  label: "Email"
                }, null, 8, ["modelValue"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})